import { __assign } from "tslib";
import React from 'react';
import { Box } from '@marvelapp/ui';
import { SpecsPanel } from '@marvelapp/ui-internal';
import ColorFill from './ColorFill';
import GradientFill from './GradientFill';
import ImageFill from './ImageFill';
var fillComponents = {
    color: ColorFill,
    image: ImageFill,
    gradient: GradientFill,
};
export default function Fills(_a) {
    var fills = _a.fills;
    var header = 'Fill';
    if (fills.length === 0) {
        return null;
    }
    if (fills.length > 1) {
        header += 's';
    }
    return (React.createElement(SpecsPanel, { title: header }, fills.map(function (fill, i) {
        var Fill = fillComponents[fill.type];
        if (fill.type === 'image') {
            // eslint-disable-next-line react/no-array-index-key
            return React.createElement(Fill, __assign({ key: i }, fill));
        }
        return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Box, { key: i },
            React.createElement(Fill, __assign({}, fill))));
    })));
}
